import { render, staticRenderFns } from "./Horoscope.vue?vue&type=template&id=c2c1598e"
import script from "./Horoscope.vue?vue&type=script&lang=js"
export * from "./Horoscope.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports